import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { ReviewService } from '../../services/Reviews.service';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import Swal from 'sweetalert2';
import { Lookup } from 'src/app/models/Lookup';
import { LookupsService } from 'src/app/services/lookups.service';

export interface DialogData {
  reviewId: number
}
@Component({
  selector: 'app-report-review-form',
  templateUrl: './report-review-form.component.html'
})
export class ReportReviewFormComponent extends DirtyComponent implements OnInit {
  override formGroup!: FormGroup;
  loading = false;
  reasonsLoading = false;

  reasons: Lookup[] = [];

  constructor(
    override dialogRef: MatDialogRef<ReportReviewFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: ReviewService,
    private lookupService: LookupsService,
    translate: TranslateService
  ) { super(translate); }

  ngOnInit(): void {
    this.buildForm();
    this.getReasons();
  }

  getReasons() {
    this.reasonsLoading = true;
    this.lookupService.GetReportFeedBackReasons()
      .subscribe(
        (data: any) => {
          this.reasonsLoading = false;
          this.reasons = data as [];
        }, (err: any) => {
          console.error(err);
        });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      reasoneId: [null, Validators.required],
      notes: [null, [
        Validators.maxLength(300)
      ]],
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        reviewId: this.data.reviewId,
        reasoneId: this.formGroup.controls['reasoneId'].value,
        notes: this.formGroup.controls['notes'].value
      };

      this.service.ResSendReport(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }
}
